export default "__VITE_ASSET__CBAW98UY__"